export const statesData = [
  {
    id: 1,
    countryCode: "AS",
    countryId: "684",
    countryImage: "assets/img/flags/as.png",
    countryName: "American Samoa (+684)",
    stateName: "Swains Island",
    key: "1"
  },
  {
    id: 2,
    countryCode: "AD",
    countryId: "376",
    countryImage: "assets/img/flags/ad.png",
    countryName: "Andorra (+376)",
    stateName: "Andorra la Vella",
    key: "2"
  },
  {
    id: 3,
    countryCode: "AO",
    countryId: "244",
    countryImage: "assets/img/flags/ao.png",
    countryName: "Angalo (+244)",
    stateName: "Benguella",
    key: "3"
  },
  {
    id: 4,
    countryCode: "AI",
    countryId: "1264",
    countryImage: "assets/img/flags/ai.png",
    countryName: "Anguilla (+1264)",
    stateName: "The Valley",
    key: "4"
  },
  {
    id: 5,
    countryCode: "AQ",
    countryId: "672",
    countryImage: "assets/img/flags/qa.png",
    countryName: "Antarctica (+672)",
    stateName: "Victoria Land",
    key: "5"
  },
  {
    id: 6,
    countryCode: "AG",
    countryId: "1268",
    countryImage: "assets/img/flags/ag.png",
    countryName: "Antigua & Barbuda (+1268)",
    stateName: "Saint Paul",
    key: "6"
  },
  {
    id: 7,
    countryCode: "AR",
    countryId: "54",
    countryImage: "assets/img/flags/ar.png",
    countryName: "Argentina (+54)",
    stateName: "Santa Fe",
    key: "7"
  },
  {
    id: 8,
    countryCode: "AU",
    countryId: "61",
    countryImage: "assets/img/flags/au.png",
    countryName: "Australia (+61)",
    stateName: "Queensland",
    key: "8"
  },
  {
    id: 9,
    countryCode: "AT",
    countryId: "43",
    countryImage: "assets/img/flags/at.png",
    countryName: "Austria (+43)",
    stateName: "Tyrol",
    key: "9"
  },
  {
    id: 10,
    countryCode: "AZ",
    countryId: "994",
    countryImage: "assets/img/flags/az.png",
    countryName: "Azerbaijan (+994)",
    stateName: "Karabakh",
    key: "10"
  },
];
